import React from "react";
import { CirclesWithBar } from "react-loader-spinner";

const LoaderSpin = ({ show }) => {
  if (!show) return null;

  return (
    <div className="loader-container">
      <div className="loader-content">
        <CirclesWithBar
          height="120"
          width="120"
          color="#4CAF50"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
          outerCircleColor="#3498db"
          innerCircleColor="#e74c3c"
          barColor="#f39c12"
          ariaLabel="circles-with-bar-loading"
        />
        <p className="loading-text">Loading...</p>
      </div>
    </div>
  );
};

export default LoaderSpin;